const TYPE_DONNEE_SITUATION = 'detailsituation';

export default TYPE_DONNEE_SITUATION;
